import { z } from 'zod';

export type ExploreEventsData = z.output<typeof exploreEventsDataSchema>;
export type ExploreEventsDataDTO = z.input<typeof exploreEventsDataSchema>;

export const exploreEventsDataSchema = z.object({
  eventCount: z.number(),
});
